import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;

	${Text} {
		font-size: 14px;
		color: #ffffff;

		&:first-child {
			opacity: 0.25;
		}
	}
`;

const StyledGroup = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	overflow: hidden;

	${StyledItem} {
		&:not(:first-child) {
			border-top: 1px solid rgba(255, 255, 255, 0.1);
		}
	}
`;

const StyledContainer = styled.div`
	height: 435px;
	overflow-y: scroll;
	padding: 0 20px;

	&::-webkit-scrollbar {
		display: none;
	}

	${StyledGroup} {
		&:not(:first-child) {
			margin-top: 20px;
		}
	}
`;

export { StyledContainer, StyledGroup, StyledHead, StyledItem };
